import type { CSSProperties, ReactNode } from 'react';
import '../../../atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../../../../infrastructure/runtime';
import { useAppFit } from '../../../../../hooks/useAppFit';
// import { CharacterBackgroundShine } from '../../../atomic/character/character_background_shine/CharacterBackgroundShine';
import { DialogBodyFrameBackground } from '../../../atomic/dialog/dialog_body_frame_background/DialogBodyFrameBackground';
import { FrameHeader } from '../../../atomic/dialog/frame_header/FrameHeader';
import type { GiantId } from '../../../../../../domain/ids/ids';
import { GiantIcon, type GiantIconVariant } from '../../../atomic/giants/giant_icons/GiantIcon';
import { SolidFrameBackground } from '../../../atomic/dialog/solid_frame_background/SolidFrameBackground';
import { SkyAtmosphere } from '../../atmosphere/sky_atmosphere/SkyAtmosphere';
import './DeliveryDialogShell.css';

export type DeliveryDialogShellProps = {
  className: string;
  giantName?: GiantId;
  /** `badge` — circular Figma badge art (new_delivery_screen). */
  giantIconVariant?: GiantIconVariant;
  /** Rendered after atmosphere, before frame (e.g. confetti behind). */
  beforeFrame?: ReactNode;
  /** Rendered after giant icon, before frame header (e.g. confetti front). */
  afterGiant?: ReactNode;
  header?: ReactNode;
  content?: ReactNode;
  actions?: ReactNode;
};

/** Shared New/Success delivery dialog layout over the delivery sky stack. */
export function DeliveryDialogShell({
  className,
  giantName = 'mona',
  giantIconVariant = 'default',
  beforeFrame,
  afterGiant,
  header,
  content,
  actions,
}: DeliveryDialogShellProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className={['app-screen', className].filter(Boolean).join(' ')}>
      <SkyAtmosphere
        variant="delivery"
        sunBeamsClassName="new-delivery-sun-beams--dialog"
      />
      <div
        className="delivery-dialog-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        {beforeFrame}
        <SolidFrameBackground />
        <DialogBodyFrameBackground />
        {/* <CharacterBackgroundShine /> */}
        <GiantIcon name={giantName} variant={giantIconVariant} />
        {afterGiant}
        <FrameHeader />
        {header}
        {content}
        {actions}
      </div>
    </div>
  );
}
